module.exports = __webpack_public_path__ + "img/lao_side.09e243e3.png";